export enum GalaxyDateDefault {
  DATE_DEFAULT_INVALID = 0,
  DATE_DEFAULT_TODAY = 1,
  DATE_DEFAULT_YESTERDAY = 2,
  DATE_DEFAULT_TOMORROW = 3,
  DATE_DEFAULT_THIS_WEEK = 4,
  DATE_DEFAULT_LAST_WEEK = 5,
  DATE_DEFAULT_NEXT_WEEK = 6,
  DATE_DEFAULT_THIS_MONTH = 7,
  DATE_DEFAULT_LAST_MONTH = 8,
  DATE_DEFAULT_NEXT_MONTH = 9,
  DATE_DEFAULT_THIS_QUARTER = 10,
  DATE_DEFAULT_LAST_QUARTER = 11,
  DATE_DEFAULT_NEXT_QUARTER = 12,
  DATE_DEFAULT_THIS_YEAR = 13,
  DATE_DEFAULT_LAST_YEAR = 14,
  DATE_DEFAULT_NEXT_YEAR = 15,
}

export enum GalaxyFilterOperator {
  FILTER_OPERATOR_INVALID = 0,
  FILTER_OPERATOR_IS_EMPTY = 1,
  FILTER_OPERATOR_IS_NOT_EMPTY = 2,
  FILTER_OPERATOR_IS = 3,
  FILTER_OPERATOR_IS_NOT = 4,
  FILTER_OPERATOR_IS_ANY = 5,
  FILTER_OPERATOR_IS_NOT_ANY = 6,
  FILTER_OPERATOR_IS_ALL = 7,
  FILTER_OPERATOR_IS_NOT_ALL = 8,
  FILTER_OPERATOR_CONTAINS = 9,
  FILTER_OPERATOR_DOES_NOT_CONTAIN = 10,
  FILTER_OPERATOR_IS_EQUAL_TO = 11,
  FILTER_OPERATOR_IS_NOT_EQUAL_TO = 12,
  FILTER_OPERATOR_IS_GREATER_THAN = 13,
  FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO = 14,
  FILTER_OPERATOR_IS_LESS_THAN = 15,
  FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO = 16,
  FILTER_OPERATOR_IS_BEFORE = 17,
  FILTER_OPERATOR_IS_BEFORE_OR_ON = 18,
  FILTER_OPERATOR_IS_AFTER = 19,
  FILTER_OPERATOR_IS_AFTER_OR_ON = 20,
  FILTER_OPERATOR_IS_BETWEEN = 21,
  FILTER_OPERATOR_IS_NOT_BETWEEN = 22,
  FILTER_OPERATOR_IS_VALID = 23,
  FILTER_OPERATOR_IS_NOT_VALID = 24,
  FILTER_OPERATOR_ANNIVERSARY_IS = 25,
}

export enum GalaxyFilterType {
  FILTER_TYPE_INVALID = 0,
  FILTER_TYPE_STRING = 1,
  FILTER_TYPE_INTEGER = 2,
  FILTER_TYPE_DATE = 3,
  FILTER_TYPE_FLOAT = 4,
  FILTER_TYPE_BOOLEAN = 5,
  FILTER_TYPE_TAG = 6,
  FILTER_TYPE_CHECKBOX = 7,
  FILTER_TYPE_PHONE = 8,
}
